import { render, staticRenderFns } from "./CardColaboracaoModerada.vue?vue&type=template&id=59107795"
import script from "./CardColaboracaoModerada.vue?vue&type=script&lang=js"
export * from "./CardColaboracaoModerada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports